import { Component, Input, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { SubirArchivoService } from "src/app/services/subir-archivo.service";
import { ReintegrosService } from "src/app/services/reintegros.service";
import { ToastrService } from "ngx-toastr";
import * as _moment from "moment";
import * as FileSaver from "file-saver";
import { DescargarArchivosService } from "src/app/services/descargar-archivos.service";
const moment = (_moment as any).default ? (_moment as any).default : _moment;
declare let $: any;

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";


@Component({
  selector: "app-download",
  templateUrl: "./download.component.html",
  styleUrls: ["./download.component.scss"]
})
export class DownloadComponent implements OnInit {

  public dataExportarExcel: any;
  public dataRefunds: any;
  public affiliate = {
    fecha_inicio: moment(new Date(2016, 1, 1), "DD/MM/YYYY").format(
      "DD/MM/YYYY"
    ),
    fecha_fin: moment(new Date(), "DD/MM/YYYY").format("DD/MM/YYYY")
  };

  @Input() type: string;
  @Input() buttonText: string;
  @Input() data: any;
  @Input() contract: any;
  @Input() disabled: true;
  public analytics: any;

  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private uploadFileService: SubirArchivoService,
    private downloadFileService: DescargarArchivosService,
    private refundsService: ReintegrosService
  ) {}

  ngOnInit() {
    this.analytics = JSON.parse(localStorage.getItem("identityCVE"));
  }

  download() {
    console.log(this.type)    
    switch (this.type) {
      case "Descargar reintegros":
        this.downloadRegisters();
        break;

      case "Pulse aquí para descargar su informe de gestión":
        this.downloadManagementReport();
        break;

      case "Descargar pagos":
        this.downloadPayments();
        break;

      default:
        break;
    }
  }

  downloadRegisters() {
    this.spinner.show();
    this.refundsService.getRefunds(this.affiliate).subscribe(
      (resp: any) => {
        if (resp) {
          this.dataRefunds = resp;
          this.uploadFileService.exportRefundsAsExcelFile(
            this.dataRefunds,
            "reintegros-mc"
          );
          (window as any).gtag("event", "descargar_reintegros", {
            event_category: `${this.analytics.v_tipo_documento} ${this.analytics.v_documento}`,
            event_label: ""
          });
        } else {
          this.toastr.warning("No hay reintegros disponibles.", null, {
            timeOut: 3000
          });
        }
      },
      (err: any) => {
        const errorMessage = $(err.error)
          .last()
          .text();
      },
      () => {
        this.spinner.hide();
      }
    );
  }

  downloadManagementReport() {
    console.log(this.contract);
    this.spinner.show();

    (window as any).gtag("event", "descargar_informe_gestion", {
      event_category: `${this.analytics.v_tipo_documento} ${this.analytics.v_documento}`,
      event_label: ""
    });

    this.downloadFileService
      .downloadManagementReport(this.contract)
      .subscribe(
        (resp: any) => {
          this.saveAsExcelFile2(resp, "informe_gestion_micovinoc");
          this.spinner.hide();
        },
        (err: any) => {
          console.error(err);
          const errorMessage = $(err.error)
            .last()
            .text();
          this.spinner.hide();
          this.toastr.warning(
            errorMessage || "No hay información disponible.",
            null,
            {
              timeOut: 4000
            }
          );
        }
      );
  }

  downloadPayments() {
    console.log(this.contract)
    this.spinner.show();

    (window as any).gtag("event", "descargar_informe_pagos", {
      event_category: `${this.analytics.v_tipo_documento} ${this.analytics.v_documento}`,
      event_label: ""
    });

    this.downloadFileService
      .downloadPaymentsReport()
      .subscribe(
        (resp: any) => {
          this.saveAsExcelFile2(resp, "informe_pagos_micovinoc");
          this.spinner.hide();
        },
        (err: any) => {
          console.error(err);
          const errorMessage = $(err.error)
            .last()
            .text();
          this.spinner.hide();
          this.toastr.warning(
            errorMessage || "No hay información disponible.",
            null,
            {
              timeOut: 4000
            }
          );
        }
      );
  }

  private saveAsExcelFile2(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName);
  }
}
